import React from "react";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";

import loginBG from "../assets/images/login_background.png";
import Logo from "../components/common/Logo";
import { TaskAlt } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const PaymentSuccess =() =>{
    const navigate = useNavigate();

    const handleBack = () => {
      navigate("/");
    };
    return (
        <>
         <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
            padding: "16px 0px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "80%",
            }}
          >
            <Logo isTitle={true} isPosition={true} />
            <TaskAlt sx={{fontSize:40, color:'#008F6C'}}/>
            
            <Typography
              variant="h1"
              fontWeight={600}
              align="center"
              sx={{ fontSize: { xs: "1rem", sm: "2rem" }, color: "#000000" }}
            >
              Your payment is successful
            </Typography>
            <Typography
              variant="h5"
              fontWeight={600}
              align="center"
              sx={{ color: "#000000" }}
              mt={2}
            >
              Thank you for your payment. we will
              be in contact with more details shortly
            </Typography>
           <br/>
           <div
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Button
                onClick={handleBack}
                fullWidth
                variant="contained"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  mt: 3,
                  mb: 2,
                  mr: 2,
                  width: "160px", // Adjust the width as needed
                  borderRadius: "20px", // Set a border radius for rounding
                  padding: "10px 16px",
                  textTransform: "capitalize",
                  backgroundColor: "#076C6B",
                  letterSpacing: 1.5,
                }}
              >
                Close
              </Button>
              </div>
          </Box>
        </Grid>
      </Grid>
        </>
    )
};

export default PaymentSuccess;